<template>
  <div class="comp-ly-add-edit" v-if="visible">
    <jw-drawer class="ly-add-edit-popup" width="100%" :header="false" :footer="false" :visible="visible" @ok="handleOk" unmountOnClose>
      <!-- 新增、编辑form表单 -->
      <ly-form v-bind="editParams" @cb="close" @cbResult="cbResult" />
    </jw-drawer>
  </div>
</template>

<script setup>
import { ref } from 'vue';
// const props = defineProps({
//   from: { type: Number, default: 1 } //1:列表 2：详情
// });
// import { setService } from '@/api/';

const emits = defineEmits(['cb', 'cbResult']);
const visible = ref(false);
// const computedError = ref(); // 计算字段错误信息

const editParams = ref({});

// 获取计算字段错误信息
// const computedErrorLog = async () => {
//   try {
//     const json = await setService.getComputedErrorLog({
//       entity: editParams.value?.entity,
//       businessIdList: [data.id]
//     });
//     if (!json.error) {
//       computedError.value = json.result;
//       console.log('计算错误信息', computedError.value);
//     }
//   } catch (e) {
//     console.log(e);
//   }
// };
// 打开编辑窗口
const open = (options) => {
  console.log('新建参数options', options);
  editParams.value = options || {};
  visible.value = true;
};
const close = (type) => {
  visible.value = false;
  // emits('cb');
  //2024年10月16日11:13:03 详情也调用callback by zl
  type === 'submit' && emits('cb');
  if (editParams.value?.entity == 16 && editParams.value?.scheduleObj?.isSchedule == true && type === 'cancel') emits('cbCancel');
};
const cbResult = (res) => {
  //如果是关联表格过来的直接吐出去数据
  if (editParams.value?.isAssociated) {
    visible.value = false;
    emits('cbResult', res);
    return false;
  }
  const resolveRes = [];
  if (Array.isArray(res)) {
    resolveRes.push(...res);
  }
  if (Array.isArray(editParams.value?.hasedIds)) {
    resolveRes.push(...editParams.value.hasedIds); // 增加任务项原有数据id
  }

  emits('cbResult', resolveRes);
};
defineExpose({
  open,
  close
});
</script>
<style scoped lang="less">
@import './ly-add-edit.less';
</style>
